import { styled, Typography } from '@mui/material';
// Types, IContact
import { isContact } from '../../types/is-contact.typeguard';
import { IContact } from '@trii/types/dist/Contacts';

const SectionTitle = styled(Typography)({
  fontWeight: 'bold',
  marginBottom: '8px',
  marginTop: '16px',
  borderBottom: `1px solid lightgray`,
});

interface BusinessSectionProps {
  contactData?: IContact;
  title: string;
}

const BusinessSection = ({ contactData, title }: BusinessSectionProps) => {
  if (!contactData || !isContact(contactData)) return null;

  return (
    <>
      <SectionTitle gutterBottom mt={2} variant="subtitle1">
        {title}
      </SectionTitle>
      <Typography variant="body2" color="text.secondary">
        {contactData?.businessName}
      </Typography>
    </>
  );
};

export default BusinessSection;
